import { ReactNode } from "react";
import nl2br from "react-nl2br";
import reactStringReplace from "react-string-replace";
import { withOperatorViewer } from "../../../helpers/ContentStudyRecordAttachmentUrlHelper";
import { RegexpHelper } from "../../../helpers/RegexpHelper";

type Props = {
  children: string | ReactNode[];
};

export const FormattedText = ({ children }: Props) => {
  return reactStringReplace(
    children,
    RegexpHelper.URL,
    (match: string, index: number) => (
      <a
        href={withOperatorViewer(match)}
        target="_blank"
        rel="noopener noreferrer"
        key={`url-${index}`}
        className="underline"
      >
        {match}
      </a>
    ),
  ).map((part: ReactNode) => nl2br(part));
};
